import { Stack } from '@mui/material';
import { lazy, Suspense, useEffect, useState } from 'react';

import { DocumentLoaderProvider } from '@/components/progress/DocumentLoader';

import { DocumentChrome } from './DocumentChrome';
import { LoadingExternal } from './LoadingExternal';
import type { PDFViewerProps } from './PDFViewer';

const LazyPDFViewer = lazy(() =>
  import('./PDFViewer').then((mod) => ({ default: mod.PDFViewer }))
);

export function PDFViewerLazy(props: PDFViewerProps) {
  // PDF.js requires browser APIs. Keep the module client-only, including SSR.
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  const Loading = props.slots?.LoadingExternal ?? LoadingExternal;
  const Chrome = props.slots?.DocumentChrome ?? DocumentChrome;
  // Use the same chrome padding and viewport before the PDF module arrives.
  const fallback = (
    <Stack width="100%" height="100%" position="relative" sx={props.sx}>
      <Chrome shouldCenterContent {...props.documentChromeProps}>
        <Loading />
      </Chrome>
    </Stack>
  );
  return (
    <DocumentLoaderProvider key={props.documentId}>
      {mounted ? (
        <Suspense fallback={fallback}>
          <LazyPDFViewer {...props} />
        </Suspense>
      ) : (
        fallback
      )}
    </DocumentLoaderProvider>
  );
}

// Export types (these are safe for SSR)
export type { PDFViewerProps } from './PDFViewer';
export type { PDFSource } from './PDFViewer.types';
